import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { PreconisationInformationDTO, PreconisationInformationDTOSchema, QueryParams0301DTO, TypeParcours } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
    providedIn: "root"
})
export class PrecoInformationsService {
    private readonly http = inject(HttpClient);
    private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, PreconisationInformationDTOSchema);

    /**
     * récupère la preconisation originale en fonction de la sélection de l'utilisateur
     * @returns preconisation
     */
    getPreconisation(montantEpargne: number, dateEffet: string, typeParcours: TypeParcours, reponses: string = null): Observable<PreconisationInformationDTO> {
        const params: QueryParams0301DTO = {
            montantEpargne,
            dateEffet,
            typeParcours: typeParcours ?? null
        };
        if (reponses) params.valeur = reponses;
        return this.http.get<PreconisationInformationDTO>(environment.urlsMs.MS0301, {
            context: this.context,
            params
        });
    }
}
